<template>
    <a-range-picker
        v-bind="$props"
        v-model:value="rangeDateValue"
        :ranges="ranges"
        @change="emitChange"
        :separator="'→'"
        :disabled="disabled"/>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue';
import moment, { Moment } from 'moment';
export default defineComponent({
    name: 'RangePickerWithPeriod',
    props: {
        ranges: {
            type: Object,
            default: () => {
                return  { 
                    '本周': [moment().startOf('week'), moment()],
                    '本季度': [moment().startOf('quarter'), moment()],
                    '本年': [moment().startOf('year'), moment()],
                    '上个月': [moment(new Date()).subtract(1, 'months').startOf('month'), moment(new Date()).subtract(1, 'months').endOf('month')],
                    '上个季度': [moment(new Date()).subtract(1, 'quarters').startOf('quarter'), moment(new Date()).subtract(1, 'quarters').endOf('quarter')],
                    '去年': [moment(new Date()).subtract(1, 'years').startOf('year'), moment(new Date()).subtract(1, 'years').endOf('year')],
                    '过去7天': [moment(new Date()).subtract(6, 'days').startOf('day'), moment()],
                    '过去30天': [moment(new Date()).subtract(29, 'days').startOf('day'), moment()],
                    '过去90天': [moment(new Date()).subtract(89, 'days').startOf('day'), moment()],
                };
            }
        },
        selected: {
            type: Array,
            default: () => []
        },
        disabled: Boolean,
    },
    emits: ['update:selected', 'change'],
    setup(props, { emit }) {
        const rangeDateValue = ref<Moment[]>([]);

        watch(() => props.selected, (value) => {
            rangeDateValue.value = value;
        }, {
            immediate: true
        });

        function emitChange(...value) {
            emit('update:selected', ...value);
            emit('change', ...value);
        }

        return {
            emitChange,
            rangeDateValue
        }
    }
})
</script>

<style lang="less" scoped>
:deep(.ant-calendar-panel) {
    display: flex;
    flex-direction: row-reverse;
}
:deep(.ant-calendar-footer-extra) {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    height: 300px;
}
:deep(.ant-calendar-picker-input) {
    width: 220px;
}
:deep(.ant-calendar-footer-extra .ant-tag-blue) {
    color: #262626;
    cursor: pointer;
    background-color: #fff;
    border: none;
    &:hover {
        background-color: #f0f7ff;
        border-radius: 2px;
    }
}
</style>